/**
 * Un área dentro de un headquarter. Puede ser una hoja —y entonces apunta a
 * su sitio de SharePoint— o tener hijos propios: la jerarquía llega a tres
 * niveles (Finanzas → Business Partner → Planning).
 */
export class HeadquarterChild {
  /** Lo asigna la base al crear; en el alta todavía no existe */
  id?: number;
  name: string = '';
  /** Clase de icono (feather) */
  icon?: string;
  /** Sitio de SharePoint del área */
  url?: string;
  /** Sub-áreas; si vienen, se navega hacia adentro en vez de abrir el sitio */
  children?: HeadquarterChild[];
}

/**
 * Un headquarter: un sitio raíz de SharePoint con sus áreas.
 *
 * Además de los datos del sitio, lleva los de presentación con los que el
 * mapa lo dibuja: dónde se apoya su edificio en el lienzo isométrico
 * (2400x1000) y qué tan grande es.
 */
export class Headquarter {
  /** Lo asigna la base al crear; en el alta todavía no existe */
  id?: number;
  name: string = '';
  /** Clase de icono (feather) */
  icon: string = '';
  /** Color base del headquarter: tiñe la azotea, el halo y el borde */
  color: string = '';
  /** Sitio de SharePoint del headquarter */
  url?: string;
  /** Cantidad de miembros; si no viene, no se muestra el subtítulo */
  members?: number;

  /** Centro de la base del edificio sobre el lienzo, eje X (0-2400) */
  x: number = 0;
  /** Centro de la base del edificio sobre el lienzo, eje Y (0-1000) */
  y: number = 0;
  /** Semi-ancho de la planta del edificio, en unidades del lienzo */
  width: number = 0;
  /** Altura del edificio, en unidades del lienzo */
  height: number = 0;

  /** Largo del cable que sube de la azotea a la pastilla */
  pin?: number;
  /** Pastilla destacada: se tiñe y lleva chevron, sin cambiar de tamaño */
  featured?: boolean;
  /** Áreas que se despliegan en el panel lateral */
  children?: HeadquarterChild[];
}
